module.exports = __webpack_public_path__ + "img/MemeETC (6).eb10935e.jpeg";